import React, { useState,useEffect } from "react";
import CompanyNavbar from "./CompanyNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
function TargetAudienceRequests() {
  const ID = Cookies.get("log_id");
  const [requests,setRequests] = useState([]);
  function Fetch_Requests() {
    axios.get(`${url.path}/fetch_cmp_target_requests/${ID}/`)
    .then((res) =>{
      if(res.data.status){
        var emp = res.data.requests;
        setRequests([])
        emp.map((e)=>{
            setRequests((prevState)=>[
                ...prevState, e
            ])
        })
    }
    }).catch((err) => {
      console.log("ERROR", err);
    });
  }
  useEffect(() =>{
    Fetch_Requests();
  }, [])
  const itemsPerPage = 3;
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const filteredData = requests.filter((item) =>
    item.Company_name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const offset = currentPage * itemsPerPage;
  const currentItems = filteredData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  function searchTable(){
    var rows = document.querySelectorAll('#productstable tbody tr');
    var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
    rows.forEach(function(row) {
      var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
      row.style.display = text.includes(val) ? '' : 'none';
    });
  }
    return(
        <>
        <CompanyNavbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>Target Requests</h3>
            </center>
            <div className="search-container">
    <input
      type="text"
      placeholder="Search..."
      onKeyUp={searchTable}
      className="search-input"
      id="search"
    />
  </div>
        <div className="table-container">
            
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Company Name</th>
            <th>Email</th>
            <th>Contact</th>
            <th>Product Name</th>
            <th>From</th>
            <th>To</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Company_name}</td>
              <td>{i.Company_mail}</td>
              <td>{i.Company_contact}</td>
              <td>{i.Product_name}</td>
              <td>{i.Start}</td>
              <td>{i.End}</td>
              <td>{i.Admin_Approved_Status}</td> 
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default TargetAudienceRequests;